import { Document } from "@documents/hooks/useDocumentsList";

/**
 * Extracts the category from a document by checking various possible sources
 * @param document The document to extract the category from
 * @param defaultCategory The default category to return if no category is found
 * @returns The document's category
 */
export const getDocumentCategory = (document: Document, defaultCategory = "Sonstige"): string => {
    // Directly from the dedicated category field
    if (document.category) {
        return document.category;
    } 
    // From metadata.category (fallback)
    else if (document.metadata && typeof document.metadata === 'object' && document.metadata.category) {
        return document.metadata.category;
    }
    
    return defaultCategory;
}; 